import { Component, OnInit } from '@angular/core';
import { InvoiceService } from '../../../services/bap/invoice.service';
import { Invoice } from '../../../models/bap/invoice.model';
import { Item } from 'angular2-multiselect-dropdown/menu-item';
import { EmsAuthService } from '../../../services';

@Component({
  selector: 'aqua-invoice-banner',
  templateUrl: './invoice-banner.component.html',
  styleUrls: ['./invoice-banner.component.css']
})
export class InvoiceBannerComponent implements OnInit {

  dues: Invoice[] = [];

  total = 0;

  showInvoice = true;

  constructor(
    private invoiceService: InvoiceService,
    private auth: EmsAuthService,
  ) {
    this.auth.roleChanges.subscribe(role => {
      if (role) {
        this.getInvoices();
      } else {
        this.dues = [];
      }
    })
  }

  ngOnInit() {
    if (this.auth.currentRole()) {
      this.getInvoices();
    }
  }

  getInvoices() {
    this.invoiceService.invoices.search().then(page => {
      this.dues = page.items;
      this.total = 0;

      this.dues.forEach(i => {
        this.total += i.amount
      })
    })
  }

  hideBanner() {
    this.showInvoice = false
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/invoice-banner/invoice-banner.component.ts